import { render } from "./CompanyWizard.vue?vue&type=template&id=3755cb98"
import script from "./CompanyWizard.vue?vue&type=script&lang=js"
export * from "./CompanyWizard.vue?vue&type=script&lang=js"

import "./CompanyWizard.vue?vue&type=style&index=0&id=3755cb98&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__